//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import card from '@/components/card/activity.vue';
import empty from '@/components/empty.vue';
import { activity_api } from '@/api/api/user';
import subscription from '@/components/subscription/subscription.vue';

let ticking = false;

export default {
  components: {
    card,
    empty,
    subscription,
  },
  data() {
    return {
      loading: false,
      page_num: 1,
      page_size: 24,
      resourceList: [],
      total: 0,
      isEmpty: false,
    };
  },
  computed: {
    emptyText() {
      return '暂没有活动';
    },
    noMore() {
      return this.total && this.resourceList.length >= this.total;
    },
    colorMode() {
      return this.$store.state.user.colorMode;
    },
  },
  mounted() {
    this.loadMoreData();
    this.$sensors.track('page_view', {
      action_position: 'community_active',
    });

    if (this.resourceList.length === 0) {
      this.initData();
    }
  },
  beforeDestroy() {
    this.clearCondition();
    window.removeEventListener('scroll', this.scrollEvent);
  },
  async asyncData({ app }) {
    // const ip = await app.$axios.$get('http://icanhazip.com');
    // return {
    //   ip,
    // };
    app.head.title = `每周创作-MasterGo 社区`;
    try {
      const params = {
        page_num: 1,
        page_size: 24,
      };
      let resourceList = [];
      let total = 0;
      const res2 = await app.$axios.$get(activity_api.list, { params });
      if (res2.code && res2.code === 'OK') {
        resourceList = res2.data || [];
        total = res2.meta.page.total;
      }
      return {
        resourceList,
        isEmpty: resourceList.length === 0,
        total,
      };
    } catch (e) {
      console.error(e);
      return {};
    }
  },
  methods: {
    scrollEvent() {
      const that = this;
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
          const clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
          const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
          const scrollTotal = scrollTop + clientHeight;
          const offsetBottom = 50;
          if (!that.noMore && !that.isEmpty && !that.loading) {
            if (scrollTotal + offsetBottom >= scrollHeight) {
              that.loadMore();
            }
          }
          ticking = false;
        });
        ticking = true;
      }
    },
    loadMoreData() {
      if (!window) {
        return;
      }
      window.addEventListener('scroll', this.scrollEvent);
    },
    clearCondition() {
      this.page_num = 1;
    },
    scrollToTop() {
      const clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
      const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      const scroll = scrollHeight - clientHeight;
      if (this.filterTop && scroll >= 0) {
        window.scrollTo({
          top: this.filterTop <= scroll ? this.filterTop : scroll - 10,
        });
      }
    },
    loadMore() {
      if (this.noMore || this.loading) return;
      this.page_num++;
      this.initData();
    },
    async initData() {
      this.loading = true;
      this.isEmpty = false;
      const params = {
        page_num: this.page_num,
        page_size: this.page_size,
      };
      const res = await this.$axios.$get(activity_api.list, { params });

      const { code, data = [], meta } = res;
      if (code === 'OK') {
        this.loading = false;
        this.total = meta.page.total;
        if (this.resourceList.length && this.page_num !== 1) {
          if (data?.length) this.resourceList.push(...data);
        } else {
          this.resourceList = data || [];
        }
        if (!this.resourceList.length) {
          this.isEmpty = true;
        }
      }
    },
    handelSubs() {
      this.$refs.subs?.addAccessNum();
    },
  },
};
